<template>
    <div id="reply">
        <div class="head-tool">
            <span @click="$router.go(-1)"><i class="el-icon-arrow-left"></i> 返回</span>
            <span class="tc">书籍评论</span>
            <span class="tr" @click="$router.push('/')">首页</span>
        </div>
        <div class="list">
            <h3>读者评论</h3>
            <ul class="reply-list" v-infinite-scroll="getReplyList" infinite-scroll-distance="200" infinite-scroll-disabled="disabled" style="overflow:auto">
                <li v-for="val in replyList">
                    <div class="fl">
                        <img :src="val.cover" alt="" :onerror.once="defaultUser">
                    </div>

                    <div class="fr">
                        <p class="nickname">{{val.nickname}} <span class="author" v-if="val.uid == author">作者</span> <span class="replyBtn" @click="sonReply(val)">回复</span></p>
                        <p class="time">{{val.create_time}}</p>
                        <p class="info" :class="{hide : !val.status}" v-html="val.content"></p>
                    </div>

                    <dl v-if="val.son">
                        <dd v-for="item in val.son" >
                            <div class="fl">
                                <img :src="item.cover" alt="" :onerror.once="defaultUser">
                            </div>

                            <div class="fr">
                                <p class="nickname">{{item.nickname}} <span class="author" v-if="item.uid == author">作者</span></p>
                                <p class="time">{{item.create_time}}</p>
                                <p class="info" v-html="item.content"></p>
                            </div>
                        </dd>
                    </dl>
                </li>

            </ul>
        </div>


    </div>
</template>

<script>
    export default {
        name: "Reply",
        data (){
            return {
                defaultUser : 'this.src="'+require('./../assets/images/user.png')+'"',
                replyList : [],
                page : 1,
                limit : 15,
                lastpage : 1,
                author : this.$route.params.author || 0,
                loading : false,
            }
        },computed:{

            getUserInfo(){
                return this.$store.getters.getUserInfo;
            },
            disabled(){
                return this.loading;
            }
        },
        methods : {
            sonReply(obj){
                if(this.getUserInfo.id > 0){
                    this.$prompt('回复 - '+obj.nickname, '提示', {
                        customClass:'replyBox',
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        inputPattern: /\S{3,30}/,
                        inputErrorMessage: '回复内容长度3-30个字'
                    }).then(({ value }) => {
                        this.axios.post("/api/reply/addReply",{
                            bid : this.$route.params.wid,
                            content : value,
                            pid:obj.id,
                        }).then(r => {
                            let data = r.data;
                            if(data.code){
                                this.$message.success(data.msg);
                                this.reply = '';
                                // this.getBookReply();
                            }else{
                                this.$message.error(data.msg);
                            }
                        })
                    }).catch(() => {

                    });
                }else{
                    if(confirm("请先登录后操作！")){
                        this.$router.push({name:"Login",query:{cburl:this.$route.path}});
                    }
                }

            },
            getReplyList(){
                if(this.page > this.lastpage){
                    return;
                }
                if(this.loading){
                    return ;
                }
                this.loading = true;
                this.axios.post('/api/reply/getReplyList',{
                    bid : this.$route.params.wid,
                    page : this.page,
                    limit : this.limit
                }).then(r => {
                    let data = r.data;
                    if(data.code){
                        this.page ++;
                        this.lastpage = data.data.last_page;
                        data.data.data.forEach(v => {
                            this.replyList.push(v)
                        })
                        this.loading = false;
                    }
                })
            }
        }
    }
</script>

<style lang="less">
    .replyBox{width: 700px !important;
        .el-message-box__title{font-size: 30px;}
        .el-message-box__headerbtn{font-size: 30px;}
        .el-message-box__message{font-size: 26px;}
        .el-input__inner{height: 50px;font-size: 30px;}
        button{font-size: 30px;}
    }
    #reply{background: #f6f6f7;height: 100%;
        .head-tool{display: flex;padding: 20px;background: #fff;
            span{flex:1;font-size: 28px;color:#333;
                i{font-size: 25px;}
            }
        }
        .list{height:calc(100% - 110px);
            background: #fff;padding: 20px;margin-top: 20px;
            h3 {
                border-left: 4px solid @theme;
                text-indent: 10px;
                margin-bottom: 20px;
                font-size: 34px;}
            .reply-list{clear: both;padding: 20px 0;height:calc(100% - 30px);
                .author{font-size: 20px;background: @theme;color: #fff;padding: 2px 10px;}

                li{margin-bottom: 20px;border-bottom: 1px solid #efefef;padding-bottom: 20px;
                    overflow: hidden;
                    .fl{width:86px;height: 86px;
                        img{width:86px;height:86px;border-radius: 50%;}

                    }
                    .fr{width: calc(100% - 120px);color:#686c62;padding-bottom: 20px;
                        .nickname{font-size: 30px;}
                        .time{
                            font-size: 24px;
                        }
                        .info{color:#6e6e6e;font-size: 24px;
                            .sendMoney{color: red;margin: 0 5px;}
                        }
                        .hide{color:#ddd !important;}
                        .replyBtn{float: right;font-size: 20px;}

                    }
                    dl{
                        float: right;width: calc(100% - 80px);padding:10px;background: #fafafa;
                        dd{margin-bottom: 10px;overflow: hidden;
                            .fl{
                                width:76px;height: 76px;
                                img{width:76px;height:76px;border-radius: 50%;}
                            }
                            .fr{width: calc(100% - 100px);color:#686c62;border-bottom: 1px solid #efefef;padding-bottom: 20px;
                                .nickname{font-size: 30px;}
                                .time{
                                    font-size: 24px;
                                }
                                .info{color:#6e6e6e;font-size: 24px;
                                    .sendMoney{color: red;margin: 0 5px;}
                                }
                            }
                        }

                    }
                }

            }
        }


    }
</style>
